"use client";

import {
  BaseAutumnProvider
} from "./chunk-5JQ57BOG.mjs";
import {
  AutumnClient
} from "./chunk-XSMSOCIP.mjs";

// src/libraries/react/ReactAutumnProvider.tsx
import { jsx } from "react/jsx-runtime";
var ReactAutumnProvider = ({
  children,
  getBearerToken,
  backendUrl,
  customerData,
  includeCredentials = true
}) => {
  let client = new AutumnClient({
    backendUrl,
    getBearerToken,
    customerData,
    includeCredentials
  });
  return /* @__PURE__ */ jsx(BaseAutumnProvider, { client, children });
};

export {
  ReactAutumnProvider
};
